<template>
  <div class="ele-body">
    <el-card shadow="never" body-style="padding-bottom: 10px;">
      <el-form
        :model="where"
        label-width="77px"
        class="ele-form-search ele-table-tool-default"
        @keyup.enter.native="searchData"
        @submit.native.prevent
      >
        <el-row :gutter="15">
          <el-col :md="6" :sm="12">
            <el-form-item label="姓名:">
              <el-input v-model="where.name" placeholder="请输入姓名" clearable />
            </el-form-item>
          </el-col>
          <el-col :md="6" :sm="12">
            <el-form-item label="宿舍:">
              <el-cascader
                v-model="dorIds"
                :options="dorData"
                :props="{ expandTrigger: 'hover', value: 'id', label: 'name', children: 'childrenList' }"
                clearable
                class="ele-block"
                @change="handleCascaderChange"
              />
            </el-form-item>
          </el-col>
          <el-col :md="6" :sm="12">
            <el-form-item label="床号:">
              <el-input v-model="where.bedNumber" placeholder="请输入床号" clearable />
            </el-form-item>
          </el-col>
          <el-col :md="6" :sm="12">
            <div class="ele-form-actions">
              <el-button type="primary" @click="searchData" icon="el-icon-search" class="ele-btn-icon" size="small">查询</el-button>
              <el-button @click="resetData" icon="el-icon-refresh-left" class="ele-btn-icon" size="small">重置</el-button>
              <el-button type="primary" @click="openExport" icon="el-icon-download" class="ele-btn-icon" size="small">导出</el-button>
            </div>
          </el-col>
        </el-row>
      </el-form>

      <ele-data-table ref="studentTable" :config="table" height="calc(100vh - 260px)" highlight-current-row>
        <template #default="{ index }">
          <el-table-column type="index" :index="index" width="45" align="center" fixed="left" show-overflow-tooltip />
          <el-table-column prop="towerName" label="宿舍楼" sortable="custom" show-overflow-tooltip />
          <el-table-column prop="storeyName" label="楼层" sortable="custom" show-overflow-tooltip />
          <el-table-column prop="roomName" label="宿舍号" sortable="custom" show-overflow-tooltip />
          <el-table-column prop="bedNumber" label="床号" sortable="custom" show-overflow-tooltip />
          <el-table-column prop="studentName" label="学生姓名" sortable="custom" show-overflow-tooltip />
          <el-table-column prop="inState" label="是否在宿舍" sortable="custom" show-overflow-tooltip>
            <template slot-scope="{ row }">
              <el-tag :type="row.inState == 0 ? 'danger' : 'success'" size="small">
                {{ row.inState == 0 ? '未归寝' : '已归寝' }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="leaveSate" label="是否请假" sortable="custom" show-overflow-tooltip>
            <template slot-scope="{ row }">
              <el-tag :type="row.leaveSate == 0 ? 'success' : 'warning'" size="small">
                {{ row.leaveSate == 0 ? '未请假' : '请假中' }}
              </el-tag>
            </template>
          </el-table-column>
        </template>
      </ele-data-table>
    </el-card>

    <el-dialog title="时间选择" :visible.sync="showExport" width="400px">
      <el-form :model="exportDateForm" ref="exportDateForm" :rules="exportDateRules" label-width="85px">
        <el-row :gutter="15">
          <el-col>
            <el-form-item label="开始时间" prop="startTime">
              <el-date-picker v-model="exportDateForm.startTime" type="date" placeholder="选择开始日期" value-format="yyyy-MM-dd" />
            </el-form-item>
            <el-form-item label="结束时间" prop="endTime">
              <el-date-picker v-model="exportDateForm.endTime" type="date" placeholder="选择结束日期" value-format="yyyy-MM-dd" />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showExport = false">取 消</el-button>
        <el-button type="primary" @click="exportData">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import { studentSignExport, towerSelect } from '@/config/dormitory/api';

  export default {
    name: 'SearchStudent',
    data() {
      return {
        where: {
          name: null,
          id: null,
          towerId: null,
          bedNumber: null,
        },
        table: {
          url: '/school/dormitory/studentSearch',
          method: 'GET',
          where: {
            name: null,
            id: null,
            towerId: null,
            bedNumber: null,
          },
          parseData(res) {
            if (res.resCode == 200) res.code = 0;
            res.count = res.data.total;
            res.data = res.data.records;
            return res;
          },
        },
        dorData: [],
        dorIds: [],
        showExport: false,
        exportDateForm: {
          startTime: null,
          endTime: null,
          id: null,
        },
        exportDateRules: {
          startTime: [{ required: true, message: '请选择开始时间', trigger: 'change' }],
          endTime: [{ required: true, message: '请选择结束时间', trigger: 'change' }],
        },
      };
    },
    mounted() {
      this.where.towerId = this.$route.query.towerId || null;
      this.table.where.towerId = this.where.towerId;
      this.getDorData();
    },
    methods: {
      getDorData() {
        const params = this.where.towerId ? { id: this.where.towerId } : undefined;
        towerSelect(params).then((res) => {
          if (res.data.resCode == 200) {
            const data = res.data.data || [];
            this.dorData = this.normalizeDormitoryOptions(Array.isArray(data) ? data : [data]);
          } else {
            this.$message.error(res.data.resMsg || '获取宿舍数据失败');
          }
        });
      },
      normalizeDormitoryOptions(list) {
        return list.map((item) => {
          const option = Object.assign({}, item);
          if (option.childrenList && option.childrenList.length) {
            option.childrenList = this.normalizeDormitoryOptions(option.childrenList);
          } else {
            delete option.childrenList;
          }
          return option;
        });
      },
      handleCascaderChange(value) {
        this.where.id = Array.isArray(value) && value.length > 0 ? value[value.length - 1] : null;
      },
      searchData() {
        this.table.where = Object.assign({}, this.where);
        this.$refs.studentTable.reload({ page: { page: 1 } });
      },
      resetData() {
        this.where = {
          name: null,
          id: null,
          towerId: this.$route.query.towerId || null,
          bedNumber: null,
        };
        this.dorIds = [];
        this.searchData();
      },
      openExport() {
        this.showExport = true;
        this.exportDateForm = {
          startTime: null,
          endTime: null,
          id: this.where.id || this.where.towerId,
        };
      },
      exportData() {
        this.$refs.exportDateForm.validate((valid) => {
          if (!valid) return;
          studentSignExport(this.exportDateForm).then((res) => {
            this.downloadBlob(res);
            this.showExport = false;
          });
        });
      },
      downloadBlob(res) {
        const blob = new Blob([res.data], {
          type: 'application/octet-stream',
        });
        const objectUrl = URL.createObjectURL(blob);
        const link = document.createElement('a');
        const disposition = res.headers['content-disposition'] || '';
        const filename = disposition ? window.decodeURI(disposition.split('=')[1], 'UTF-8') : '考勤数据.xlsx';
        link.style.display = 'none';
        link.href = objectUrl;
        link.setAttribute('download', filename);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(objectUrl);
      },
    },
  };
</script>

<style scoped>
  .ele-block {
    width: 100%;
  }
</style>
